import { render } from "./SendInvestigationModal.vue?vue&type=template&id=65368064"
import script from "./SendInvestigationModal.vue?vue&type=script&lang=js"
export * from "./SendInvestigationModal.vue?vue&type=script&lang=js"

import "./SendInvestigationModal.vue?vue&type=style&index=0&id=65368064&lang=scss"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__